<template>
<div class="lead-form-container">        
    <div id="header-action" class="header-sticky">
        <div class="container-header">
            <div class="header-logo">
                <img :src="$api.ste.logo" class="logo-small" alt="Logo"/>
            </div>
            <div class="header-spacer"></div>
            <div class="header-cta" v-if="contact.user_telephone != undefined">
                <b-button class="call-button" :class="{'pulse': call_color === 'danger'}" variant="danger" :href="`tel:${contact.user_telephone}`">
                    <i class="fas fa-phone mr-2"></i>
                    <span class="call-text">Appelez-nous</span>
                </b-button>
            </div>
        </div>
    </div>        
    <b-container v-if="ready" class="main-content">
        <b-row class="justify-content-center">
            <b-col lg="12">                
                <transition name="fade-slide">
                    <b-card class="modern-card success-card" v-if="send">
                        <div class="success-content">
                            <div class="success-icon">
                                <i class="fas fa-check-circle fa-1x text-primary"></i>
                            </div>
                            <h2 class="success-title">Merci pour votre demande !</h2>
                            <p class="success-message">
                                Votre demande a bien été enregistrée. Un conseiller vous contactera dans les plus brefs délais.
                            </p>
                            <div class="success-image">
                                <img src="https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?w=800&q=80" alt="Service client"/>
                            </div>
                            <div class="text-center mt-4" v-if="contact.user_telephone != undefined">
                                <b-button class="cta-button" variant="primary" size="lg" :href="`tel:${contact.user_telephone}`">
                                    <i class="fas fa-phone mr-2"></i>
                                    Appelez-nous maintenant
                                </b-button>
                            </div>
                        </div>
                    </b-card>
                </transition>                    
                
                <transition name="fade-slide">
                    <b-card class="modern-card form-card" v-if="!send">                        
                        <div class="form-header">
                            <h1 class="form-title">{{ contact.titre }}</h1>
                            <p class="form-subtitle">Obtenez votre devis gratuit en quelques minutes</p>
                        </div>                            
                        <div class="benefits-section">
                            <div class="benefit-item">
                                <div class="benefit-icon">
                                    <i class="fas fa-check text-white"></i>
                                </div>
                                <span>Devis gratuit</span>
                            </div>
                            <div class="benefit-item">
                                <div class="benefit-icon">
                                    <i class="fas fa-clock text-white"></i>
                                </div>
                                <span>Réponse rapide</span>
                            </div>
                            <div class="benefit-item">
                                <div class="benefit-icon">
                                    <i class="fas fa-hand-holding-heart text-white"></i>
                                </div>
                                <span>Sans engagement</span>
                            </div>
                        </div>                            
                        <form ref="form" class="modern-form">                            
                            <div class="form-section">
                                <h3 class="section-title">
                                    <i class="fas fa-user"></i>
                                    Vos informations personnelles
                                </h3>
                                <b-row>
                                    <b-col md="6" class="mb-3">
                                        <div class="input-group-modern">
                                            <label class="input-label">
                                                <i class="fas fa-user"></i>
                                                Nom
                                            </label>
                                            <b-form-input type="text" v-model="contact.nom" placeholder="Votre nom" required class="modern-input"/>
                                        </div>
                                    </b-col>
                                    <b-col md="6" class="mb-3">
                                        <div class="input-group-modern">
                                            <label class="input-label">
                                                <i class="fas fa-user"></i>
                                                Prénom
                                            </label>
                                            <b-form-input type="text" v-model="contact.prenom" placeholder="Votre prénom" required class="modern-input"/>
                                        </div>
                                    </b-col>
                                    <b-col md="6" class="mb-3">
                                        <div class="input-group-modern">
                                            <label class="input-label">
                                                <i class="fas fa-phone"></i>
                                                Téléphone
                                            </label>
                                            <b-form-input type="text" v-model="contact.telephone_1" placeholder="Votre téléphone" minlength="10" maxlength="10" required class="modern-input"/>
                                        </div>
                                    </b-col>
                                    <b-col md="6" class="mb-3">
                                        <div class="input-group-modern">
                                            <label class="input-label">
                                                <i class="fas fa-envelope"></i>
                                                Email
                                            </label>
                                            <b-form-input type="text" v-model="contact.email" placeholder="votre@email.com" required class="modern-input"/>
                                        </div>
                                    </b-col>
                                    <b-col md="6" class="mb-3" v-if="form_complet">
                                        <div class="input-group-modern">
                                            <label class="input-label">
                                                <i class="fas fa-map-marker-alt"></i>
                                                Code postal
                                            </label>
                                            <b-form-input type="text" v-model="contact.cp" placeholder="75001" class="modern-input"/>
                                        </div>
                                    </b-col>
                                    <b-col md="6" class="mb-3" v-if="form_complet">
                                        <div class="input-group-modern">
                                            <label class="input-label">
                                                <i class="fas fa-calendar"></i>
                                                Date de naissance
                                            </label>
                                            <b-form-input placeholder="JJ/MM/AAAA" v-model="contact.date_naissance" @input="e => formatDate(e, 'p')" maxlength="10" required class="modern-input"/>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </div>                                
                                <div class="form-section" v-if="form_complet && false">
                                    <h3 class="section-title">
                                        <i class="fas fa-clipboard-list"></i>
                                        Votre mutuelle actuelle
                                    </h3>
                                    <b-row>
                                        <b-col md="6" class="mb-3">
                                            <div class="input-group-modern">
                                                <label class="input-label">
                                                    <i class="fas fa-building"></i>
                                                    Nom de votre mutuelle
                                                </label>
                                                <b-form-input type="text" v-model="contact.actuelle_mutuelle" placeholder="Ex: Harmonie Mutuelle" class="modern-input"/>
                                            </div>
                                        </b-col>
                                        <b-col md="6" class="mb-3">
                                            <div class="input-group-modern">
                                                <label class="input-label">
                                                    <i class="fas fa-euro-sign"></i>
                                                    Cotisation mensuelle
                                                </label>
                                                <b-form-input type="text" v-model="contact.actuelle_cotisation" placeholder="Ex: 80€" class="modern-input"/>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </div>                                
                                <div class="form-section" v-if="form_complet">
                                    <h3 class="section-title">
                                        <i class="fas fa-users"></i>
                                        Votre situation familiale
                                    </h3>
                                    <b-row>
                                        <b-col md="6" class="mb-3">
                                            <div class="checkbox-modern">
                                                <b-form-checkbox v-model="contact.conjoint.regime_id" :value="1" :unchecked-value="null" size="lg">
                                                    <i class="fas fa-heart mr-2"></i>
                                                    Avez-vous un conjoint ?
                                                </b-form-checkbox>
                                            </div>
                                        </b-col>
                                        <b-col md="6" class="mb-3" v-if="contact.conjoint.regime_id === 1">
                                            <div class="input-group-modern">
                                                <label class="input-label">
                                                    <i class="fas fa-calendar"></i>
                                                    Date de naissance du conjoint
                                                </label>
                                                <b-form-input placeholder="JJ/MM/AAAA" v-model="contact.conjoint.date_naissance" @input="e => formatDate(e, 'c')" maxlength="10" required class="modern-input"/>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </div>                                
                                <div class="form-section rgpd-section" :class="{ 'optin-error': optinError }" ref="optin">
                                    <div class="checkbox-modern rgpd-checkbox">
                                        <b-form-checkbox v-model="optin" size="lg" id="optin26" :aria-invalid="optinError ? 'true' : null" aria-describedby="optin-error-msg">
                                            <div class="rgpd-text px-2">
                                                <i class="fas fa-shield-alt mr-2"></i>
                                                En cliquant sur "Obtenir mon devis", vous acceptez que vos données soient utilisées par l'Assureur Français pour vous contacter par e-mail et par téléphone à propos de votre demande de devis.
                                            </div>
                                        </b-form-checkbox>
                                    </div>
                                    <div v-if="optinError" id="optin-error-msg" class="optin-error-msg" role="alert">
                                        <i class="fas fa-exclamation-circle mr-1"></i>
                                        Merci de cocher cette case pour recevoir votre devis.
                                    </div>
                                </div>
                                <!-- Subtitle -->
                                <div class="form-note" v-if="contact.sous_titre">
                                    <i class="fas fa-info-circle"></i>
                                    {{ contact.sous_titre }}
                                </div>
                            </form>                            
                            <div class="text-center mt-4 mb-3">
                                <b-button variant="primary" size="lg" class="submit-button" @click="save" :disabled="contactLoad">
                                    <span v-if="!contactLoad">
                                        <i class="fas fa-paper-plane mr-2"></i>
                                        Obtenir mon devis gratuit
                                    </span>
                                    <span v-else>
                                        <i class="fas fa-spin fa-spinner mr-2"></i>
                                        Envoi en cours...
                                    </span>
                                </b-button>
                            </div>
                        </b-card>
                    </transition>
                </b-col>
            </b-row>
        </b-container>        
        <footer class="site-footer">
            <div class="footer-content">
                <div class="footer-text">
                    <strong>L'Assureur Français</strong> — Copyright 2023 — Tel :
                    <a href="tel:0800211211" class="footer-link">0800 211 211</a> —
                    Intermédiaire en assurance sous le n° Orias <a href="https://www.orias.fr/home/showIntermediaire/443503784" class="footer-link">07 022 530</a> —
                    <a href="https://assureur-francais.fr/mentions-legales/" class="footer-link">Mentions légales</a> —
                    Adresse : 145 rue de Charonne, 75011 Paris
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
    export default {
        name: "LeadForm",
        computed: {},
        data() {
            return {
                ready: false,
                call_color: 'primary',
                send:false,
                contactLoad:false,
                form_complet: false,
                optin: false,
                optinError: false,
                contact:{
                    titre:"Formule de contact",
                    sous_titre:"",
                    regime_id:1,
                    nom:null,
                    prenom:null,
                    email:null,
                    telephone_1:null,
                    code:null,
                    actuelle_mutuelle: null,
                    actuelle_cotisation: null,
                    conjoint:{
                        regime_id: null,
                        date_naissance: null
                    },
                    commentaire: null
                }
            }
        },
        watch:{
            optin(v){
                if(v){
                    this.optinError = false;
                }
            },
            'contact.date_naissance'(v){
                var v2 = this.contact.conjoint.date_naissance;
                var txt = "";
                if(v != null){
                    txt += "Date de naissance: "+v;
                }
                if(v2 != null){
                    txt += "\n";
                    txt += "Date de naissance du conjoint: "+ v2;
                }
                this.contact.commentaire = txt;
            },
            'contact.conjoint.date_naissance'(v2){
                var v = this.contact.date_naissance;
                var txt = "";
                if(v != null){
                    txt += "Date de naissance: "+v;
                }
                if(v2 != null){
                    txt += "\n";
                    txt += "Date de naissance du conjoint: "+ v2;
                }
                this.contact.commentaire = txt;
            }
        },
        beforeMount(){
            if(this.$route.params.q != undefined){
                var base64 = this.$route.params.q;
                const binaryString = atob(base64);
                const bytes = Uint8Array.from(binaryString, char => char.charCodeAt(0));
                const decodedString = new TextDecoder('utf-8').decode(bytes);
                var params = JSON.parse(decodedString);
                console.log(params);
                
                if(params.form_complet != undefined){
                    this.form_complet = params.form_complet;
                    delete params.form_complet;
                }
                this.contact = {... this.contact, ...params};
            }
        },
        mounted() {
            setInterval(() => {
                this.call_color = this.call_color === 'primary' ? 'danger' : 'primary';
            }, 2000)
            this.ready = true;
        },
        methods: {
            save(){
                if(this.contactLoad === true){
                    return true;
                }
                if(!this.checkForm()){
                    return false;
                }
                this.contactLoad = true;
                this.$api.ajax('/campagne/new', {...this.contact, meta_url: location.href}, res => {
                    if(res.status === true){
                        this.send = true;
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                    this.contactLoad = false;
                })
            },
            checkForm(){
                var form = this.$refs.form;
                var fields = form.querySelectorAll("[required='required']");
                var valide = true;
                var premierInvalide = null;
                fields.forEach((item) => {
                    if(item.checkValidity() === false){
                        item.classList.add("need-validation");
                        valide = false;
                        premierInvalide = premierInvalide || item;
                    }else{
                        item.classList.remove("need-validation");
                    };
                });
                this.optinError = !this.optin;
                if(valide && !this.optinError){
                    return true;
                }
                var message = 'Merci de remplir tous les champs obligatoires';
                if(valide){
                    message = 'Merci de cocher la case d\'acceptation pour obtenir votre devis';
                }else if(this.optinError){
                    message += ' et de cocher la case d\'acceptation';
                }
                this.$bvToast.toast(message, {
                    title: 'Champs requis',
                    variant: 'warning',
                    solid: true
                });
                this.tabIndex = 0;
                if(premierInvalide){
                    premierInvalide.reportValidity(); // bulle du navigateur + défilement sur le 1er champ en erreur
                }else{
                    this.$refs.optin.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
                return false;
            },
            reload(){
                location.reload()
            },
            formatDate(event, type) {
                let input = event.replace(/\D/g, '');
                if (input.length > 8) {
                    input = input.slice(0, 8);
                }
                if (input.length > 2 && input.length <= 4) {
                    input = input.slice(0, 2) + '/' + input.slice(2);
                } else if (input.length > 4) {
                    input = input.slice(0, 2) + '/' + input.slice(2, 4) + '/' + input.slice(4);
                }
                if(type === 'p'){
                    this.contact.date_naissance = input;
                }else if(type === 'c'){
                    this.contact.conjoint.date_naissance = input;
                }
            },
        },
    }
</script>

<style lang="scss">
/* Color Palette */
:root {
    --primary-color: #2563EB;
    --primary-dark: #1E40AF;
    --primary-light: #3B82F6;
    --danger-color: #DC2626;
    --text-dark: #1F2937;
    --text-light: #6B7280;
    --bg-light: #F3F4F6;
    --border-color: #E5E7EB;
    --shadow-sm: 0 1px 3px rgba(0,0,0,0.1);
    --shadow-md: 0 4px 6px rgba(0,0,0,0.1);
    --shadow-lg: 0 10px 15px rgba(0,0,0,0.1);
}

body {
    background: none !important;
}

/* Animations */
@keyframes fadeSlideIn {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes pulse {
    0%, 100% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.05);
    }
}

/* Transitions */
.fade-slide-enter-active, .fade-slide-leave-active {
    transition: all 0.4s ease;
}
.fade-slide-enter, .fade-slide-leave-to {
    opacity: 0;
    transform: translateY(20px);
}

/* Container */
.lead-form-container {
    min-height: 100vh;
    background: #F9FAFB;
    position: relative;
    padding-bottom: 80px;
}

/* Header Sticky */
.header-sticky {
    position: sticky;
    top: 0;
    background: white;
    border-bottom: 2px solid #2563EB;
    z-index: 1000;
    padding: 10px 0;
}

.container-header {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    display: flex;
    align-items: center;
}

.header-logo {
    flex-shrink: 0;
}

.logo-small {
    max-width: 250px;
    height: auto;
}

.header-spacer {
    flex-grow: 1;
}

.call-button {
    font-weight: 600;
    padding: 10px 20px;
    border-radius: 8px;
    transition: all 0.3s ease;
    border: none;
    font-size: 15px;

    &.pulse {
        animation: pulse 1.5s infinite;
    }

    &:hover {
        transform: translateY(-2px);
    }
}

.call-text {
    font-size: 15px;
}

/* Main Content */
.main-content {
    padding: 30px 20px 60px;
    position: relative;
}

/* Modern Card */
.modern-card {
    border: none;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    overflow: hidden;
    animation: fadeSlideIn 0.6s ease;
    background: white;
    margin-bottom: 40px;
}

/* Form Header */
.form-header {
    background: linear-gradient(135deg, #2563EB 0%, #1E40AF 100%);
    color: white;
    padding: 30px;
    text-align: center;
    border-radius: 20px;
}

.form-title {
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 10px;
    line-height: 1.3;
}

.form-subtitle {
    font-size: 16px;
    margin: 0;
}

/* Benefits Section */
.benefits-section {
    display: flex;
    justify-content: space-around;
    padding: 25px 20px;
    background: white;
    border-bottom: 1px solid var(--border-color);
    flex-wrap: wrap;
    gap: 20px;
}

.benefit-item {
    display: flex;
    align-items: center;
    gap: 10px;
    color: var(--text-dark);
    font-weight: 500;
    font-size: 14px;
}

.benefit-icon {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #1F2937;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
}

/* Form Sections */
.modern-form {
    padding: 40px 30px 20px;
    background: #FAFBFC;
}

.form-section {
    margin-bottom: 35px;
}

.section-title {
    font-size: 17px;
    font-weight: 600;
    color: var(--text-dark);
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 10px;

    i {
        color: var(--text-dark);
        font-size: 18px;
    }
}

/* Input Groups */
.input-group-modern {
    position: relative;
}

.input-label {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    font-weight: 600;
    color: var(--text-dark);
    margin-bottom: 6px;

    i {
        color: var(--text-dark);
        font-size: 14px;
    }
}

.modern-input {
    border: 1px solid #D1D5DB;
    border-radius: 6px;
    padding: 10px 14px;
    font-size: 14px;
    transition: all 0.2s ease;
    background: white;

    &:focus {
        border-color: #2563EB;
        outline: none;
        box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
    }

    &::placeholder {
        color: #9CA3AF;
    }
}

/* Checkbox Modern */
.checkbox-modern {
    padding: 15px;
    background: white;
    border-radius: 6px;
    border: 1px solid #D1D5DB;

    .custom-control-label {
        font-weight: 500;
        color: var(--text-dark);
        cursor: pointer;
        font-size: 14px;
    }
}

/* RGPD Section */
.rgpd-section {
    background: #F3F4F6;
    border-radius: 6px;
    padding: 10px;
    margin-top: 25px;
}

.rgpd-checkbox {
    padding: 0;
    background: transparent;
    border: none;
    .custom-control-label {
        font-weight: 400;
    }
}

.rgpd-text {
    font-size: 14px;
    line-height: 1.6;
    // color: var(--text-light);
}

/* Form Note */
.form-note {
    background: #EFF6FF;
    padding: 15px;
    border-radius: 6px;
    color: var(--primary-dark);
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 20px;
    font-size: 14px;

    i {
        font-size: 16px;
    }
}

/* Submit Button */
.submit-button {
    font-size: 16px;
    font-weight: 600;
    padding: 14px 40px;
    border-radius: 8px;
    border: none;
    background: linear-gradient(135deg, #2563EB 0%, #1E40AF 100%);
    box-shadow: var(--shadow-md);
    transition: all 0.3s ease;

    &:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: var(--shadow-lg);
    }

    &:disabled {
        opacity: 0.7;
        cursor: not-allowed;
    }
}

/* Success Card */
.success-card {
    text-align: center;
}

.success-content {
    padding: 60px 30px;
}

.success-icon {
    font-size: 70px;
    color: #10B981;
    margin-bottom: 25px;
    animation: fadeSlideIn 0.6s ease;

    i {
        animation: pulse 2s infinite;
    }
}

.success-title {
    font-size: 28px;
    font-weight: 700;
    color: var(--text-dark);
    margin-bottom: 15px;
}

.success-message {
    font-size: 16px;
    color: var(--text-light);
    line-height: 1.6;
    margin-bottom: 30px;
}

.success-image {
    margin: 30px 0;
    border-radius: 8px;
    overflow: hidden;

    img {
        width: 100%;
        height: auto;
        max-height: 300px;
        object-fit: cover;
    }
}

.cta-button {
    font-size: 16px;
    font-weight: 600;
    padding: 14px 40px;
    border-radius: 8px;
    animation: pulse 2s infinite;
}

/* Site Footer */
.site-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #1F2937;
    color: white;
    padding: 15px 0;
    box-shadow: 0 -2px 10px rgba(0,0,0,0.1);
    z-index: 999;
}

.footer-content {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 20px;
}

.footer-text {
    font-size: 12px;
    line-height: 1.6;
    text-align: center;
    color: #D1D5DB;

    strong {
        color: white;
        font-weight: 600;
    }
}

.footer-link {
    color: #60A5FA;
    text-decoration: none;
    transition: color 0.2s ease;

    &:hover {
        color: #93C5FD;
        text-decoration: underline;
    }
}

/* Validation */
.rgpd-section.optin-error {
    background: #FEF2F2;
    box-shadow: 0 0 0 2px var(--danger-color);
    animation: shake 0.5s;
    .custom-control-label::before {
        border-color: var(--danger-color) !important;
    }
}

.optin-error-msg {
    color: var(--danger-color);
    font-size: 14px;
    font-weight: 600;
    margin-top: 8px;
    padding: 0 5px;
}

.need-validation {
    border-color: var(--danger-color) !important;
    animation: shake 0.5s;
}

@keyframes shake {
    0%, 100% { transform: translateX(0); }
    25% { transform: translateX(-10px); }
    75% { transform: translateX(10px); }
}

/* Responsive */
@media (max-width: 768px) {
    .container-header {
        flex-direction: column;
        gap: 12px;
    }

    .header-spacer {
        display: none;
    }

    .logo-small {
        max-width: 150px;
    }

    .call-button {
        width: 100%;
        padding: 10px 20px;
    }

    .form-title {
        font-size: 24px;
    }

    .form-subtitle {
        font-size: 15px;
    }

    .benefits-section {
        flex-direction: column;
        text-align: center;
        padding: 20px 15px;
    }

    .benefit-item {
        justify-content: center;
    }

    .modern-form {
        padding: 30px 20px;
    }

    .section-title {
        font-size: 16px;
    }

    .submit-button {
        width: 100%;
        padding: 14px 30px;
    }

    .success-title {
        font-size: 24px;
    }

    .success-message {
        font-size: 15px;
    }

    .footer-text {
        font-size: 11px;
        line-height: 1.8;
    }

    .site-footer {
        padding: 12px 0;
    }
}

@media (max-width: 576px) {
    .main-content {
        padding: 20px 10px 60px;
    }

    .modern-card {
        border-radius: 6px;
    }

    .form-header {
        padding: 40px 20px;
    }

    .form-title {
        font-size: 22px;
    }

    .modern-form {
        padding: 25px 15px;
    }

    .footer-text {
        font-size: 10px;
    }
}

#optin26, .custom-checkbox.b-custom-control-lg .custom-control-label::after, .input-group-lg .custom-checkbox .custom-control-label::after , .custom-checkbox.b-custom-control-lg .custom-control-label::before, .input-group-lg .custom-checkbox .custom-control-label::before {
    height: 1.75rem !important;
    width: 1.75rem !important;
}
</style>
